import s from './ProductNotes.scss';
import * as React from 'react';

export const Devider = () => (
  <div className={s.dividerContainer}>
    <div className={s.divider} data-testid='divider' />
  </div>
);
